/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type accessBlocked_viewer$ref: FragmentReference;
declare export opaque type accessBlocked_viewer$fragmentType: accessBlocked_viewer$ref;
export type accessBlocked_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +accessBlocked: ?boolean,
  |},
  +$refType: accessBlocked_viewer$ref,
|};
export type accessBlocked_viewer$data = accessBlocked_viewer;
export type accessBlocked_viewer$key = {
  +$data?: accessBlocked_viewer$data,
  +$fragmentRefs: accessBlocked_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accessBlocked_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessBlocked",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e6204168de6dcac5341b3f0f2ae55756';

module.exports = node;
